import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
// fade animation related AOS
import Aos from "aos";
import "aos/dist/aos.css";
//
// zoom in related
// import { motion } from "framer-motion";
//<motion.  add this to any img you want to scale
//
//
//

const About = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //
  //
  //
  //

  return (
    <React.Fragment>
      <section id="about">
        <div className="about___wrapper">
          {/* 
        
        
        
        
        
        */}

          <div className="header__Top1">
            {/* heading */}{" "}
            <div className="header__Top1__title">
              <h1 data-aos-duration="1000" data-aos="fade-up">
                ABOUT
              </h1>
            </div>
            <div className="header__Top1__titleTab">
              <h2> 3D Artist &#x26; Creative Technologist</h2>
              <p> 2008 | 2021</p>
            </div>
          </div>

          {/* 
        
        
        
        
        
        */}

          {/* ---------- */}
          {/*   Descript ROW */}
          <div className="descript__row">
            <div className="descript__row__wrapper">
              <div className="descript__row_heading">
                <h1 data-aos-duration="1000" data-aos="fade-up">
                  WHO I AM
                </h1>
                <h2>WHAT I DO</h2>
                {/* <h3>The Simurgh Mount </h3> */}

                <p>Art Direction</p>
                <p>Concept Art</p>
                <p>Illustration</p>
                <p> Modeling</p>
                <p> Texturing</p>
                <p> Lighting</p>
                <p>Web Design</p>
              </div>
              <div className="descript__row_article">
                <h1>
                  <br />
                  Volkanuve is a 3D Artist &#x26; Creative Developer who until
                  several years ago,
                  <span>
                    channeled her bountiful imagination in ephemeral
                    illustrations, until her focus shifted to technology.
                  </span>{" "}
                  Since then, she has endeavored to learn and specialize herself
                  in the field of 3D design, specifically for the game industry,
                  with the ultimate goal of developing software applicable to VR
                  environments. She loves to experiment with mashups between
                  creative concepts and different languages and technologies.
                  Her decade-long experience in illustration opened a gateway to
                  3D design , which enabled her to learn{" "}
                  <span>
                    skills in Blender, Autodesk 3ds Max, After Effects and
                    Photoshop to name a few.{" "}
                  </span>{" "}
                  In addition to that she is also familiar with technology and
                  development such as PHP &#x26; MySQL, Javascript, React,
                  HTML5, THREEjs(WebGL) amongst others.
                </h1>
              </div>
            </div>
          </div>

          {/* 
        
        
        
        
        
        */}

          <div className="folio_BG_scroll">
            {/* heading */}
            <div className="folio_BG_scroll_containerImg"></div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default About;
